const HYBRID_DRAFT_PARAM = 'hybrid_draft'
const HYBRID_LAUNCH_PARAM = 'hybrid_launch'
const HYBRID_LAUNCH_STORAGE_PREFIX = 'fusegrid_hybrid_launch:'

type LaunchLocation = Pick<Location, 'pathname' | 'search'>

function hybridReportDraftId(loc: LaunchLocation | null | undefined): string {
  if (!loc) return ''
  return String(new URLSearchParams(String(loc.search || '')).get(HYBRID_DRAFT_PARAM) || '').trim()
}

export function hybridReportLaunchDraftId(
  loc: LaunchLocation | null | undefined,
  storage: Pick<Storage, 'getItem'> | null | undefined = typeof window === 'undefined' ? null : window.sessionStorage,
): string {
  const pathname = String(loc?.pathname || '')
  if (!/^\/[^/]+\/workbooks\/[^/]+\/cfo\/presentations\/?$/.test(pathname)) return ''
  const draftId = hybridReportDraftId(loc)
  if (!draftId) return ''
  const params = new URLSearchParams(String(loc?.search || ''))
  const queryToken = String(params.get(HYBRID_LAUNCH_PARAM) || '').trim()
  let storedToken = ''
  try {
    storedToken = String(storage?.getItem(`${HYBRID_LAUNCH_STORAGE_PREFIX}${draftId}`) || '').trim()
  } catch {
    storedToken = ''
  }
  const token = queryToken || storedToken
  return /^fghr_[A-Za-z0-9_-]{32,256}$/.test(token) ? draftId : ''
}

export function isHybridReportLaunchLocation(
  loc: LaunchLocation | null | undefined,
  storage?: Pick<Storage, 'getItem'> | null,
): boolean {
  return Boolean(hybridReportLaunchDraftId(loc, storage))
}
